export default __webpack_public_path__ + "static/media/dashboard-icon-orange.c7cbc37b.svg";